import Iframe from "@components/CustomTypography/Iframe/Iframe"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CustomerHeader.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
}

const CustomerHeader = (props: Props) => {
	return (
		<div className={styles.headerContainer}>
			<div className={styles.contentWrapper}>
				<div className={styles.contentBox}>
					<Typography
						content={props.data.title}
						variant={Variant.SectionTitle}
						as={"h2"}
					/>
					<Typography
						content={props.data.subtitle}
						variant={Variant.SectionSubtitle}
					/>
				</div>
				<div className={styles.buttonBox}>
					<ButtonSwitcher buttonsList={props.data} withoutTarget />
				</div>
			</div>
			<div className={styles.iframeWrapper}>
				{props.data.preview && <Iframe {...props.data.preview} />}
			</div>
		</div>
	)
}

export default CustomerHeader
